import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import '@/registerServiceWorker'

Vue.config.productionTip = false

import { db, auth } from '@/firebase'
import { firestorePlugin } from 'vuefire'
Vue.use(firestorePlugin)

import CKEditor from '@ckeditor/ckeditor5-vue';
Vue.use( CKEditor );

let app = ''

auth.onAuthStateChanged(function() {
    if(!app){
		new Vue({
			router, //exportat variable a todo los componentes
			render: h => h(App)
		}).$mount('#app')
    }
})

require('moment/locale/es')
import moment from 'moment'
//Vue.use(moment)

//Filtros
Vue.filter('formatNumber', function(clean){
	var value = clean.toString().replace(/(?!^-)[^0-9.]/g,'')
	var prefijo = '$'
	if(value < 0){
		prefijo = '-$'
	}
	return prefijo + value.replace(/[^0-9.]/g,'').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})

Vue.filter('formatEntero', function(clean){
	var value = parseInt(clean.toString().replace(/(?!^-)[^0-9]/g,''))
	if(isNaN(value)){
		return 0
	}else{
		return value
	}
})

Vue.filter('formatDecimal', function(clean){
	var value = clean.toString().replace(/(?!^-)[^0-9.]/g,'')
	if(value != '.' && isNaN(value)){
		return 0
	}else{
		return value
	}
})

Vue.filter('formatMesesPorcentaje', function(clean){
	var value = clean.toString().replace(/(?!^-)[^0-9.]/g,'')
	if(isNaN(value)){
		return 0
	}else{
		let val = value.toString().replace(',', '').replace('-', '')
		return val
	}
})

Vue.filter('formatFloat', function(clean){
	var value = clean.toString().replace(/(?!^-)[^0-9.]/g,'')
	if(isNaN(value)){
		return 0.00
	}else{
		let val = value.toString().replace(',', '').replace('-', '')
		return parseFloat((val/1).toFixed(2))
	}
})

Vue.filter('cleanFormat', function(clean){
	var value = clean.toString().replace(/(?!^-)[^0-9.]/g,'')
	return value
})

Vue.filter('formatPrice', function(value){
	if(isNaN(value)){
		return '$0.00'
	}else{
		let val = (value/1).toFixed(2)
		var type_mount = '-$'
		if(value >= 0){
			type_mount = '$'
		}
		return type_mount + val.toString().replace('-', '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
	}
})

Vue.filter('simpleFormatDate', function(value) {
	if(value) {
		const curdate = new Date(null)
		const date = curdate.setTime(value*1000)
		const momentdate = curdate.toISOString()
		return moment(momentdate).format('dddd DD [de] MMMM [de] YYYY')
	}
})

Vue.filter('singleFormatDate', function(value) {
	if(value) {
		const curdate = new Date(null)
		const date = curdate.setTime(value*1000)
		const momentdate = curdate.toISOString()
		return moment(momentdate).format('DD [de] MMMM [de] YYYY')
	}
})

Vue.filter('beautyFormatDate', function(value) {
	if(value) {
		const curdate = new Date(null)
		const date = curdate.setTime(value*1000)
		const momentdate = curdate.toISOString()
		return moment(momentdate).format('HH:mm MMM DD, YYYY')
	}
})

Vue.filter('timerFormatDate', function(value) {
	if(value) {
		const curdate = new Date(null)
		const date = curdate.setTime(value*1000)
		const momentdate = curdate.toISOString()
		return moment(momentdate).format('DD MMMM h:mm a')
	}
})

Vue.filter('monthFormatDate', function(value) {
	if(value) {
		const curdate = new Date(null)
		const date = curdate.setTime(value*1000)
		const momentdate = curdate.toISOString()
		return moment(momentdate).format('MMM YYYY')
	}
})

Vue.filter('quoteFormatDate', function(value) {
	if(value) {
		const curdate = new Date(null)
		const date = curdate.setTime(value*1000)
		const momentdate = curdate.toISOString()
		return moment(momentdate).format('MMMM-DD-YYYY')
	}
})

Vue.filter('folioFormatDate', function(value) {
	if(value) {
		const curdate = new Date(null)
		const date = curdate.setTime(value*1000)
		const momentdate = curdate.toISOString()
		return moment(momentdate).format('DDMMYYYY')
	}
})

Vue.filter('initialText', function(value) {
	return value.substring(0, 1).toUpperCase()
})

Vue.filter('cutText', function(value) {
	var limit = 30
	if(value.length > (limit + 1)){
		return value.substring(0, limit) + '...'
	}else{
		return value
	}
})

Vue.filter('resumeText', function(value) {
	if(value.length > 101){
		return value.substring(0, 100) + '...'
	}else{
		return value
	}
})

Vue.filter('clearHtmlTextCut', function(value) {
	var regex = /(<([^>]+)>)/ig;
	if(value.length > 0){
		value = value.replace(regex, '')
	}
	if(value.length > 101){
		return value.substring(0, 100) + '...'
	}else{
		return value
	}
})

Vue.filter('createFolio', function(servicios, cliente) {
	var client_version = ''
	var desglose_servicios = ''
	if(servicios){
		desglose_servicios = servicios
	}

	if(cliente){
		if(cliente.empresa){
			client_version += cliente.empresa + '_'
		}
		if(cliente.contacto){
			client_version += cliente.contacto
		}
	}

	return client_version + '_' + desglose_servicios
})